<app-mobile-header-secondary title="{{ 'webhooks.accessWebhooks' | translate }}"></app-mobile-header-secondary>

<div class="mobile mobile__page-in-construction">
  <div class="mobile__message mobile__message--red">
    <b>{{ 'external.availableForDesktop' | translate }}</b>
  </div>
</div>

<article class="configuration-item d-none d-lg-block">
  <div class="configuration-container">
    <div class="configuration-content">
      <div class="configuration-title">
        {{ 'webhooks.webhooksOf' | translate }} <span class="highlight">{{ currentUser?.organization?.name }}</span>
      </div>
      <div class="configuration-text">{{ 'webhooks.webhooksTriggeredWhenOrganizationDocumentSigned' | translate }}</div>
      <div class="configuration-documentation">
        @if (urlParamsService.params.documentationLink && !enterpriseService.hideForEnterprise()) {
          <a href="https://docs.autentique.com.br/" class="configuration-documentation__text" target="_blank">
            <i class="fa-regular fa-circle-question"></i>
            {{ 'button.accessDocumentation' | translate }}
          </a>
        }
      </div>
    </div>
  </div>
  <div class="section">
    <div class="section__header">
      <h2 class="section__title">Endpoints</h2>
      <button (click)="openCreateEndpointModal()" class="section__button"><i class="fa-regular fa-plus"></i>{{ 'webhooks.addEndpoint' | translate }}</button>
    </div>

    <ng-template #noEndpoints>
      <div *ngIf="!legacyWebhooks?.url" class="division">
        <div class="division__section" [loadingAnimation]="isLoading">
          <p class="division__log__empty">{{ 'webhooks.noRegisterOfHooks' | translate }}</p>
        </div>
      </div>
    </ng-template>

    <ng-container *ngIf="webhooksList?.length > 0; else noEndpoints">
      <div [loadingAnimation]="isLoading" class="endpointLine" *ngFor="let endpoint of webhooksList">
        <div class="endpointLine__group">
          <p
            class="endpointLine__group__name"
            [ngClass]="{
              'endpointLine__group__name-blocked': endpoint.blocked,
              'endpointLine__group__name-inactive': !endpoint.active && !endpoint.blocked
            }"
          >
            {{ endpoint.name }}
          </p>
          <i
            class="fa-regular fa-webhook endpointLine__group__firstIcon"
            [ngClass]="{
              'endpointLine__group__firstIcon-blocked': endpoint.blocked
            }"
          ></i>
          <p
            class="endpointLine__group__url"
            [ngClass]="{
              'endpointLine__group__url-blocked': endpoint.blocked,
              'endpointLine__group__url-inactive': !endpoint.active && !endpoint.blocked
            }"
          >
            {{ endpoint.url }}
          </p>
          <i class="fal fa-clone endpointLine__group__seccondIcon" (click)="copyToClipboard(endpoint.url)"></i>
          <p
            class="endpointLine__group__status"
            [ngClass]="{
              'endpointLine__group__status-blocked': endpoint.blocked,
              'endpointLine__group__status-success': endpoint.active && !endpoint.blocked,
              'endpointLine__group__status-inactive': !endpoint.active && !endpoint.blocked
            }"
          >
            {{ endpoint.blocked ? ('webhooks.blockedHook' | translate) : endpoint.active ? ('webhooks.activeHook' | translate) : ('webhooks.inactiveHook' | translate) }}
          </p>
        </div>
        <div class="endpointLine__groupRight">
          <div class="endpointLine__groupRight__firstIcon">
            <i class="fa-regular fa-code icon"></i>
            <p>{{ getFriendlyWebhookFormatName(endpoint.format) }}</p>
          </div>
          <div>
            <p>{{ endpoint.success_rate }}%</p>
          </div>
          <div appDropdown placement="bottom-right">
            <button type="button" class="dropdown__toggle-control dropdown__toggle-control--icon-only" appDropdownToggle>
              <i class="far fa-ellipsis-v"></i>
            </button>

            <div appDropdownMenu>
              <button type="button" appDropdownItem (click)="editEndpoint(endpoint)"><i class="fa-regular fa-edit icon"></i> {{ 'button.edit' | translate }}</button>

              @if (endpoint.blocked) {
                <button type="button" appDropdownItem (click)="unblockEndpoint(endpoint.id)"><i class="fa-regular fa-lock icon"></i> {{ 'button.unblock' | translate }}</button>
              }

              <button type="button" appDropdownItem (click)="deactivateEndpoint(endpoint.id, endpoint.active)">
                <i class="fa-regular fa-power-off icon"></i> {{ endpoint.active ? ('webhooks.deactivateHook' | translate) : ('webhooks.activateHook' | translate) }}
              </button>

              <button type="button" class="dropdown__item--danger" appDropdownItem (click)="deleteWebhookEndpoint(endpoint.id)">
                <i class="fa-regular fa-trash"></i> {{ 'button.exclude' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- LEGACY WEBHOOKS -->
    <div class="endpointLine" *ngIf="legacyWebhooks?.url && !isLoading">
      <div class="endpointLine__group">
        <p class="endpointLine__group__name">{{ 'webhooks.callbackURL' | translate }}</p>
        <i class="fa-regular fa-webhook endpointLine__group__firstIcon"></i>
        <p class="endpointLine__group__url">{{ legacyWebhooks?.url }}</p>
        <i class="fal fa-clone endpointLine__group__seccondIcon" (click)="copyToClipboard(legacyWebhooks?.url)"></i>
      </div>
      <div class="endpointLine__groupRight">
        <ng-template #legacy>
          <div class="tooltip__title tooltip__descr">
            {{ 'webhooks.legacyHookWarning' | translate }}
          </div>
        </ng-template>
        <div class="legacy" [ngbTooltip]="legacy">
          <i class="fal fa-exclamation-triangle"></i>
          <p style="cursor: default">{{ 'webhooks.legacy' | translate }}</p>
        </div>
        <div class="endpointLine__groupRight__firstIcon">
          <i class="fa-regular fa-code icon"></i>
          <p>{{ legacyWebhooks?.format }}</p>
        </div>
        <div style="color: var(--clr-structure-white)">
          <p>x%</p>
        </div>
        <div class="endpointLine__ellipsis" ngbDropdown placement="bottom-right">
          <button type="button" class="endpointLine__ellipsis__dropdown" ngbDropdownToggle>
            <i class="fa-regular fa-ellipsis-vertical"></i>
          </button>
          <div ngbDropdownMenu>
            <button (click)="deleteLegacyEndpoint()" ngbDropdownItem><i class="fa-regular fa-trash icon"></i> {{ 'button.exclude' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- LEGACY WEBHOOKS END -->
  </div>

  <div>
    <div class="section__header">
      <h2 class="section__title">{{ 'webhooks.errorLogs' | translate }}</h2>
    </div>

    <ng-template #noLogs>
      <div [loadingAnimation]="isLoading || isLoadingErrorLogs" class="division">
        <div class="division__section">
          <p class="division__log__empty">{{ 'webhooks.noErrorRegisterReceived' | translate }}</p>
        </div>
      </div>
    </ng-template>

    <div *ngIf="(groupedFailedWebhooks || {} | keyvalue).length > 0; else noLogs" class="d-flex">
      <div class="division">
        <div class="division__section" *ngFor="let date of sortedDates">
          <p class="division__log__day">{{ date | ldate: 'mediumDate' }}</p>
          <ng-container *ngFor="let log of groupedFailedWebhooks[date]">
            <div
              class="division__log"
              [@logAnimation]
              [loadingAnimation]="isResendingWebhook && selectedLog?.id === log.id"
              [ngClass]="{ 'division__log-selected': log.id === selectedLog?.id }"
              (click)="selectedLog = log"
            >
              <div class="division__log__line">
                <div class="division__log__status">{{ log.status_code }}</div>
                <div class="division__log__url">{{ log.payload?.url || log.webhook_endpoint.url }}</div>
              </div>
              <div class="division__log__time">{{ log.failed_at | date: 'HH:mm:ss' }}</div>
            </div>
          </ng-container>
        </div>
        @if (hasMorePages) {
          <div class="text-center mt-3">
            <button type="button" class="btn btn-link" (click)="loadMoreFailedWebhookPages()">{{ 'button.loadMore' | translate }}</button>
          </div>
        }
      </div>
      <div *ngIf="selectedLog.id" class="division__sectionRight">
        <div class="response">
          <div class="response__title">
            <h2 class="">{{ 'webhooks.responseHook' | translate }}</h2>
            <button
              class="response__button"
              [ngClass]="{ disabled: isResendingWebhook || !selectedLog?.id }"
              [disabled]="isResendingWebhook || !selectedLog?.id"
              (click)="resendFailedWebhook(selectedLog.id)"
            >
              {{ 'button.resend' | translate }}
            </button>
          </div>
          <div class="response__body">
            <div class="response__line">
              <p class="response__key">
                {{ 'webhooks.status' | translate }} <span class="response__value">{{ selectedLog?.status_code }}</span>
              </p>
            </div>
            <div class="response__line">
              <p class="response__key">
                {{ 'webhooks.time' | translate }} <span class="response__value"> {{ selectedLog?.failed_at | ldate: 'medium' }}</span>
              </p>
            </div>
            <div class="response__line">
              <p class="response__key">
                {{ 'webhooks.ipAdress' | translate }} <span class="response__value">{{ selectedLog?.ip }}</span>
              </p>
            </div>
            <div class="response__line">
              <p class="response__key">
                {{ 'webhooks.reason' | translate }} <span class="response__value">{{ selectedLog?.reason }}</span>
              </p>
            </div>
            <div class="response__line">
              <p class="response__key">
                {{ 'webhooks.attempts' | translate }} <span class="response__value">{{ selectedLog?.attempts }}</span>
              </p>
            </div>
            <div class="response__line">
              <p class="response__key">
                {{ 'webhooks.nextAttempt' | translate }} <span class="response__value">{{ selectedLog?.next_attempt_at | ldate: 'short' }}</span>
              </p>
            </div>
            <div class="response__line">
              <p class="response__key">
                {{ 'webhooks.ttl' | translate }} <span class="response__value">{{ selectedLog?.ttl | ldate: 'short' }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="response">
          <div class="response__title">
            <h2 class="mt-2">{{ 'webhooks.responseBody' | translate }}</h2>
          </div>
          <div class="response__body">
            <div class="response__clone">
              <i class="fal fa-clone" (click)="copyToClipboard(selectedLog?.response_body)"></i>
            </div>
            <pre class="response__json">{{ selectedLog?.response_body || selectedLog?.error_message }}</pre>
          </div>
        </div>
        <div class="response">
          <div class="response__title">
            <h2 class="mt-2">{{ 'webhooks.payload' | translate }}</h2>
          </div>
          <div class="response__body">
            <div class="response__clone">
              <i class="fal fa-clone" (click)="copyToClipboard()"></i>
            </div>
            @if (selectedLog?.payload?.format == WebhookFormatEnum.Json.toLowerCase()) {
              <pre class="response__json">{{ selectedLog?.payload | json }}</pre>
            } @else {
              <pre class="response__urlencode">{{ selectedLog?.payload | urlencode }}</pre>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</article>
